/*@ngInject*/
const FormDropdownUnselectItemDirective = function (coreConstant) {
        return {
            require: 'uiSelect',
            link: function ($scope, $element, $attr, $select) {
                var currentItem,
                    searchInput = $element.querySelectorAll('input.ui-select-search'),
                    directiveIdentifier = $attr.dropdownUnselectItem,
                    handleSearchInputFocus = function () {
                        $scope.$apply(function () {
                            $select.activate();
                            if (_.isNil(currentItem)) {
                                $select.activeIndex = -1;
                            }
                        });
                    };

            searchInput.on('focus.unselectItem.dropdown', handleSearchInputFocus);

                $scope.$on('$destroy', function () {
                    searchInput.off('focus.unselectItem.dropdown', handleSearchInputFocus);
                });

                $scope.$on(coreConstant.event.dropdown.DROPDOWN_ITEM_CHANGED, function (event, item, identifier) {
                    if (_.isEmpty(directiveIdentifier) || identifier === directiveIdentifier) {
                        currentItem = item;
                    }
                });
            }
        };
    };

angular.module('umCore')
    .directive('dropdownUnselectItem', FormDropdownUnselectItemDirective);
